"use client";

import { useEffect } from "react";
import { useCookieConsent } from "@leabankab/component-library/cookie-consent/react";
import { useRuntimeConfig } from "@/contexts/runtime-config";
import { setGtmAnalyticsConsent } from "./gtm";

export const GtmInit = () => {
	const { consent } = useCookieConsent();
	const { gtmContainerId } = useRuntimeConfig();
	const hasAnalyticsConsent = consent?.analytics === true;

	useEffect(() => {
		setGtmAnalyticsConsent(gtmContainerId, hasAnalyticsConsent);
	}, [gtmContainerId, hasAnalyticsConsent]);

	return null;
};
